export default "<teams-list [initialTeams]=\"initialTeams\"></teams-list>\n";